// extracted by mini-css-extract-plugin
export default {"PopoverContainer":"_PopoverContainer--VtZOf","Popover":"_Popover--isHav","scaleIn":"_scaleIn--GdbXG"};